// src/pages/admin/AdminCourses.jsx
import React, { useEffect, useState } from "react";
import api from "../../services/axiosInstance";
import { FaTrash, FaSearch } from "react-icons/fa";

const AdminCoursesDelete = () => {
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  // Fetch all courses
  const fetchCourses = async () => {
    try {
      const { data } = await api.get("/courses");
      setCourses(data);
      setFilteredCourses(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setLoading(false);
    }
  };

  // Delete course
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this course?")) return;

    try {
      await api.delete(`/courses/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const updated = courses.filter((course) => course.id !== id);
      setCourses(updated);
      setFilteredCourses(updated);
    } catch (error) {
      console.error("Error deleting course:", error);
    }
  };

  // Handle search
 const handleSearch = (e) => {
  const value = e.target.value.toLowerCase();
  setSearch(value);

  const filtered = courses.filter((course) =>
    (course.name?.toLowerCase() || "").includes(value) ||
    (course.instructor_name?.toLowerCase() || "").includes(value) ||
    (course.category?.toLowerCase() || "").includes(value)
  );

  setFilteredCourses(filtered);
};


  useEffect(() => {
    fetchCourses();
  }, []);

  if (loading)
    return (
      <div className="pt-32 text-center text-gray-700">Loading courses...</div>
    );

  return (
    <div className="pt-32 px-8 pb-8 bg-gray-50 min-h-screen">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">All Courses</h1>

      {/* Search Bar */}
      <div className="mb-6 flex items-center max-w-md bg-white border rounded shadow px-3 py-2">
        <FaSearch className="text-gray-400 mr-2" />
        <input
          type="text"
          placeholder="Search by name, instructor or category..."
          value={search}
          onChange={handleSearch}
          className="w-full outline-none text-gray-700"
        />
      </div>

      {filteredCourses.length === 0 ? (
        <p className="text-gray-600">No courses found.</p>
      ) : (
        <div className="overflow-x-auto shadow rounded-lg bg-white">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase tracking-wider">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase tracking-wider">
                  Instructor
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase tracking-wider">
                  Category
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase tracking-wider">
                  Price
                </th>
                <th className="px-6 py-3 text-center text-sm font-medium text-gray-700 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredCourses.map((course) => (
                <tr key={course.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-gray-800">
                    {course.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-800">
                    {course.instructor_name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-800">
                    {course.category}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-800">
                    {course.price}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                    <button
                      onClick={() => handleDelete(course.id)}
                      className="text-red-600 hover:text-red-800 transition-colors duration-200"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminCoursesDelete;
